var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHierarchyFileIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hierarchyFileIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 14.5c.275 0 .5-.225.5-.5V5H10c-.553 0-1-.447-1-1V1.5H4c-.275 0-.5.225-.5.5v12c0 .275.225.5.5.5h8ZM2 2c0-1.103.897-2 2-2h5.172a2 2 0 0 1 1.415.584l2.829 2.829A2 2 0 0 1 14 4.828V14c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V2Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hierarchyFileIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 0h12v16H2z"
})))));
export default SvgHierarchyFileIcon;